import React from "react";
import { formatCurrency } from "../view-util.js";
import Card from "./Card";

const Flow = ({ flow, settings, updateImagePickerStory, visible = true, toggleDescription, storyDescriptions = {} }) => {
  const price = (flow) => {
    return flow.stories.reduce((a, b) => a + (b.size || 0), 0) * settings.pointPrice;
  };

  // Always show all stories, regardless of tag selection
  // We'll use the visible property only for opacity control
  const storiesToShow = flow.stories;
  
  // Style for faded content
  const fadedStyle = {
    opacity: visible ? 1 : 0.25,
    transition: 'opacity 0.3s ease'
  };

  // Always render the flow, regardless of visibility
  // We'll control the opacity with CSS instead

  return (
    <div className="flow section content pb-4 pt-0" style={fadedStyle}>
      <h2 className="flow-title page-break-before">
        {flow.name}
        {flow.tags && flow.tags.length > 0 && (
          <span className="tags ml-2">
            {flow.tags.map(tag => (
              <span key={tag} className="tag is-info is-light">{tag}</span>
            ))}
          </span>
        )}
      </h2>
      <p className="flow-description">{flow.description}</p>
      <div className="flow-cards">
        {storiesToShow.map((story) => {
          // Prepare story with toggle functionality
          const storyWithToggle = {
            ...story,
            toggleDescription: toggleDescription ? () => toggleDescription(story) : story.toggleDescription,
            showFullDescription: storyDescriptions[story.lineNo]?.showFullDescription || false
          };
          
          return (
            <Card 
              key={story.lineNo} 
              story={storyWithToggle} 
              updateImagePickerStory={updateImagePickerStory} 
              visible={story.visible}
            />
          );
        })}
      </div>
      {settings.showPoints || settings.showPrice ? (
        <div className="flow-footer">
          {settings.showPoints ? (
            <span className="flow-points">
              {storiesToShow.reduce((a, b) => a + (b.size || 0), 0)} points&nbsp;
            </span>
          ) : null}
          {settings.showPrice ? (
            <span className="flow-price">
              {formatCurrency(storiesToShow.reduce((a, b) => a + (b.size || 0), 0) * settings.pointPrice, settings.currency)}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default Flow;
